import {Image} from './Image';
import {AgeGroup} from './AgeGroup';
import {CompetitionSeason} from './CompetitionSeason';
import {Team} from './Team';
import {Club} from './Club';
import {Season} from './Season';
import {Contact} from './Contact';
import {Profile} from './Profile';

interface NextTeamSeasonRef {
  readonly slug: string;
  readonly season: Season | null;
}

/**
 * Represents a seasonal team. A seasonal team may exist as a syndicate,
 * meaning that it consists of teams of different clubs.
 */
export class TeamSeason {
  readonly id: number;
  /** id of over-seasonal team, in case of a syndicate, this is the main */
  readonly teamId: number;
  readonly slug: string;
  readonly name: {
    middle: string | null;
    full: string | null;
    short: string | null;
  };
  readonly image: Image;
  readonly teamImage: Image | null;
  readonly origin: string;
  readonly ageGroup?: AgeGroup;
  readonly competition?: CompetitionSeason | null;
  readonly linkUrl: string;
  readonly level: number;
  readonly clubSlug?: string;
  readonly club?: Club | null;
  /** all participating teams in case of a syndicate */
  readonly teams?: Team[];
  /** over-seasonal team, in case of a syndicate, this is the main */
  readonly team?: Team;
  readonly nextTeamSeason?: NextTeamSeasonRef | null;
  readonly contacts?: Contact[];
  readonly withoutScoring?: boolean;
  readonly syndicate?: boolean;
  readonly captain?: Profile | null;
  readonly viceCaptain?: Profile | null;
  readonly withdraw?: boolean | null;
  readonly seasonTarget?: string | null;
  readonly targetDescription?: string;
  readonly championFavourit?: string;
  /** league standing */
  readonly rank?: number;
}
